export const tabs = [
  { value: "invoice_number", title: "Invoice No." },
  { value: "invoice_amount", title: "Invoice Amount" },
];

export const VENDOR_ID = "vendorId";
export const DATE_RANGE = "dateRange";
export const START_DATE = "postingStartDate";
export const END_DATE = "postingEndDate";
export const INVOICE_STATUS = "invoiceStatus";
export const CREATED_BY = "createdBy";
export const PAYMENT_STATUS = "paymentState";
export const DUE_DAYS = "dueDays";

export const invoiceStatusOptions = [
  { label: "Parked", value: "DRAFT" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Posted", value: "POSTED" },
];

export const paymentStatusOptions = [
  { label: "Paid", value: "PAID" },
  { label: "0-9 Days", value: "lt10" },
  { label: "10-19 Days", value: "btw10_20" },
  { label: "20+ Days", value: "gt_20" },
];
